<template>
  <svg
    :width="taille"
    :height="taille"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path v-for="(d, i) in TRACES[nom]" :key="i" :d="d" />
  </svg>
</template>

<script setup lang="ts">
/**
 * Pictogrammes du menu. Un dessin par entrée se reconnaît AVANT d'avoir lu le
 * libellé, et c'est tout ce qui reste visible quand la barre est repliée.
 * Tracés inline : pas de police d'icônes à charger pour six dessins.
 */
type NomIcone = 'accueil' | 'declarations' | 'nouvelle' | 'validation' | 'paie' | 'admin' | 'boussole' | 'point';

const TRACES: Record<NomIcone, string[]> = {
  accueil: ['M3 11.5 12 4l9 7.5', 'M5.5 9.5V20h13V9.5', 'M10 20v-5h4v5'],
  declarations: ['M7 3h7l5 5v13H7z', 'M14 3v5h5', 'M10 13h6', 'M10 17h6'],
  nouvelle: ['M12 5v14', 'M5 12h14'],
  validation: ['M4 12.5 9 17.5 20 6.5'],
  paie: ['M3 7h18v10H3z', 'M7 12h.01', 'M17 12h.01', 'M12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z'],
  admin: [
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    'M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z',
  ],
  boussole: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M15.5 8.5 13.4 13.4 8.5 15.5 10.6 10.6z'],
  point: ['M12 12h.01'],
};

withDefaults(defineProps<{ nom: NomIcone; taille?: number }>(), { taille: 18 });
</script>
